module.exports = wx;


//////////////////
// WEBPACK FOOTER
// external "wx"
// module id = zTYp
// module chunks = 233